import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Pagination,
  TableFooter,
  LinearProgress,
  Typography,
} from '@mui/material';
import { useStyles } from './SignInActivitiesPage.styles';
import { useSignInActivitiesData } from './hooks/useSignInActivitiesData';
import { DataState } from '@shared/enums/DataState';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { totalSignInActivitiesSelector } from './redux/selectors';
import { formatDateTime } from './helpers';
import { DataErrorView } from '@shared/components/DataErrorView';

const LIMIT = 10;

export const SignInActivitiesPage: React.FC = () => {
  const [pagination, setPagination] = useState({ limit: LIMIT, offset: 0 });
  const { data, error, state } = useSignInActivitiesData(pagination);
  const isDataLoading = state === DataState.Pending;
  const styles = useStyles();
  const rows = data?.data || [];
  const total = useSelector(totalSignInActivitiesSelector);
  const isShowPagination = total > LIMIT;

  return error ? (
    <DataErrorView error={error} />
  ) : (
    <Box>
      <TableContainer
        component={Paper}
        elevation={1}
        sx={{
          borderRadius: 0,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            padding: '16px',
            background: 'white',
          }}
        >
          Your sign in activity
        </Typography>

        <Table>
          <TableHead>
            <TableRow className={styles.tableHeader}>
              <TableCell>Date</TableCell>
              <TableCell></TableCell>
              <TableCell>Browser / Device</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>IP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {isDataLoading && (
              <TableRow
                className="noCustomStyles"
                sx={{
                  height: '4px !important',
                }}
              >
                <TableCell
                  colSpan={5}
                  sx={{
                    padding: '0px !important',
                  }}
                >
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {!isDataLoading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="h3">No sign in activity yet</Typography>
                </TableCell>
              </TableRow>
            )}
            {rows.map((row) => {
              const formattedDate = formatDateTime(row.createdAt);
              return (
                <TableRow key={row.id}>
                  <TableCell>{formattedDate.date}</TableCell>
                  <TableCell>{formattedDate.time}</TableCell>
                  <TableCell>{row.device}</TableCell>
                  <TableCell>{row.location}</TableCell>
                  <TableCell>{row.ip}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          {isShowPagination && (
            <TableFooter>
              <TableCell
                colSpan={5}
                sx={{
                  padding: '8px',
                  paddingLeft: 0,
                }}
              >
                <Pagination
                  size="large"
                  count={Math.ceil(total / LIMIT) || 0}
                  onChange={(_, value) => setPagination({ ...pagination, offset: (value - 1) * LIMIT })}
                />
              </TableCell>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Box>
  );
};
